<template>
  <div
    ref="notification"
    class="notification-container"
    @mouseenter="removeTimeout"
    @mouseleave="() => attachTimeout(3000)"
    @click="() => $destroy()"
    :class="type"
  >
    <span>{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: "Notification",
  props: ["text", "type"],
  data() {
    return {
      destroyTimeout: false,
    };
  },
  mounted() {
    this.attachTimeout(5000);
    this.$refs.notification.classList.add("notification-active");
  },
  beforeDestroy() {
    this.$refs.notification.classList.remove("notification-active");
    setTimeout(() => {
      this.$el.parentNode.removeChild(this.$el);
    }, 500);
  },
  methods: {
    removeTimeout() {
      clearTimeout(this.destroyTimeout);
      this.destroyTimeout = null;
    },
    attachTimeout(ms) {
      this.destroyTimeout = setTimeout(() => {
        this.$destroy();
      }, ms);
    },
  },
};
</script>

<style scoped>
.notification-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 20px;
  box-shadow: 12px 10px 19px 7px rgba(0, 0, 0, 0.62);
  opacity: 0;
  transition: opacity 0.5s;
}

.notification-container span {
  color: white;
  font-weight: bold;
}

.notification-container span:first-letter {
  text-transform: capitalize;
}

.notification-active {
  opacity: 1;
}
.warning {
  background-color: rgb(255, 141, 114);
}

.error {
  background-color: rgb(201, 48, 48);
}

.success {
  background-color: rgb(57, 193, 108);
}

.info {
  background-color: rgb(31, 141, 248);
}
</style>
